export const VIEW_TRACKING_ENDPOINT = `/api/track-view`;
export const LOCATION_SEARCH_ENDPOINT = `/api/location/search`;
export const AUTH_USER = `/api/user`;
export const SIGN_UP_PRELOAD = `/api/sign-up/preload`;
export const PROFILE_EDIT_PREFETCH_DATA_ENDPOINT = `/api/profile-edit-prefetch-data`;
export const PROFILE_EDIT_ENDPOINT = `/api/profile-edit`;
export const POSTING_PREFETCH_DATA_ENDPOINT = `/api/posting-prefetch-data`;
export const POSTING_VALIDATE_ENDPOINT = `/api/posting-validate`;
export const POSTING_ENDPOINT = `/api/posting`;
export const POSTING_LOG_ENDPOINT = `/api/posting-log`;
export const POSTING_EDIT_PREFETCH_DATA_ENDPOINT = `/api/posting-edit-prefetch-data`;
export const APPLY_VALIDATE_ENDPOINT = `/api/apply/validate`;
export const APPLY_PREFETCH_DATA_ENDPOINT = `/api/apply/prefetch-data`;
export const APPLY_ENDPOINT = `/api/apply/send`;
export const APPLY_CONNECT_ENDPOINT = `/api/apply/connect`;
export const POSTING_EDIT_ENDPOINT = `/api/posting-edit`;
export const PASSWORD_EDIT_ENDPOINT = `/api/password-edit`;
export const UPDATE_PAYMENT_METHOD_ENDPOINT = `/api/update-payment-method`;
export const PREFETCH_PAYMENT_ENDPOINT = `/api/prefetch-payment`;
export const SIGN_UP_COMPANY_INFORMATION_ENDPOINT = `/api/sign-up/employer/company-information`;
export const ADD_A_PAYMENT_METHOD_ENDPOINT = `/api/sign-up/employer/add-a-payment-method`;
export const COMPANY_PROFILE_ENDPOINT = `/api/sign-up/employer/company-profile`;
export const SIGN_UP_PERSONAL_INFORMATION_ENDPOINT = `/api/sign-up/student/personal-information`;
export const SIGN_UP_EDUCATIONAL_BACKGROUND_ENDPOINT = `/api/sign-up/student/educational-background`;
export const SIGN_UP_STUDENT_PROFILE_ENDPOINT = `/api/sign-up/student/profile`;

export const RESUME_CONTACT_A_STUDENT_ENDPOINT = `/api/resume/contact-a-student/send`;
